export default __webpack_public_path__ + "static/media/banner4.f58cec01.png";